import { CRBTUICSSStyle, CRBTUICSSStyleImpl } from '../crbt/crbtuicss';
import { Fonts } from '../../../../utils/resources/fonts';
import { Colors } from '../../../../utils/resources/colors';

export interface DoItYourselfCSSStyle extends CRBTUICSSStyle
{
    getDoItYourselfTextCSSStyle(): object;
    getTitleTextCSSStyle(): object;
    getTuneNameCSSStyle(): object;
    getUploadCSSStyle(): object;
    getSubmitCSSStyle(isDisabled:boolean): object;
    getRowDivCSSStyle(): object;
    getReadCSSStyle(): object;
    getTermsConditionsCSSStyle(): object;
}

export class DoItYourselfCSSStyleImpl extends CRBTUICSSStyleImpl implements DoItYourselfCSSStyle
{
    getWrapperCSSStyle()
    {
        return{
            width: "100%",
            paddingLeft: "5%",
            paddingRight: "5%",
            textAlign: "center"
        };
    }

    
    getReadCSSStyle(): object {
        return {
            display: "inline-block",
            // textAlign: this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH ? "left" : "right",
            height: "20px",
            letterSpacing: 0,
            fontSize: this.getResources().getFont(Fonts.h7),
            color:this.getResources().getColor(Colors.color_7),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "20px",
            paddingLeft: "15px",
            paddingRight: "5px",
        };
    }

    getRowDivCSSStyle(): object 
    {
        return {
            width:'100%',
        
            display: "flex",
            position: "relative",
            flexDirection: "row",
            flexFlow: "row wrap",
            justifyContent:"center"
        };
    }

    getTermsConditionsCSSStyle(): object 
    {
        return {
            display: "inline-block",
            // textAlign: this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH ? "left" : "right",
            height: "20px",
            letterSpacing: 0,
            fontSize: this.getResources().getFont(Fonts.h6),
            color:this.getResources().getColor(Colors.color_6),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "20px",
            fontWeight: "bold",
            textDecoration: "underline"
        };
    }

    getTuneNameCSSStyle(): object 
    {
        return{
            width: "320px",
            // justifyContent: "center",
            display: "inline-block",
            // flexFlow: "row wrap",
            marginTop: "30px"
        };
    } 

    getDoItYourselfTextCSSStyle(): object {
        return {
            fontSize: this.getResources().getFont(Fonts.h16),
            color: this.getResources().getColor(Colors.color_6),
            fontFamily: this.getResources().getFontFamily(),
            fontWeight: 900,
            letterSpacing: 0,
            lineHeight: "80px",
            width: "100%",
            textAlign: "center",
        };
    }
    getTitleTextCSSStyle(): object {
        return {

            textAlign: "center",
            fontSize: this.getResources().getFont(Fonts.h12),
            color:this.getResources().getColor(Colors.color_32),
            fontFamily: this.getResources().getFontFamily(),
            fontWeight: 500,
            letterSpacing: 0,
            lineHeight: "30px",
            // height: "60px",
            width: "100%",
            marginTop: "20px",
          };
    }

    getUploadCSSStyle(): object 
    {
        return{
            width: "100%",
            justifyContent: "center",
            display: "flex",
            flexFlow: "row wrap",
            marginTop: "40px"
        };
    } 

    getSubmitCSSStyle(isDisabled:boolean): object {
        if(isDisabled)
        {
            return{
                width: "180px",
                 display: "inline-block",
                 marginTop: "25px",
                 margin: "0 !important",
                 marginBottom:'40px',
                 opacity:'30%'
     
             };
        }
        else
        {
            return{
                width: "180px",
                 display: "inline-block",
                 marginTop: "25px",
                 margin: "0 !important",
                 marginBottom:'40px',
     
             };
        }
      
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/doityourself/doityouselfcss.tsx